export enum CurationType {
  PUBLISHER_DEALS = 'P',
  OX_UNITS = 'O',
  EXTERNAL_SSP_DEALS = 'S',
}
